export default "__VITE_ASSET__BsguIRdP__"